import React from "react";

const FallbackDashboard = React.lazy(
  () => import("../pages/home/fallback/FallbackDashboard"),
);

export const fallbackRoutes = [
  {
    path: "/workspace",
    element: <FallbackDashboard />,
    title: "School Workspace",
    description: "A role-aware overview for school operations and priorities.",
    allowedRoles: [
      "manager",
      "principal",
      "teacher",
      "receptionist",
      "coordinator",
      "operator",
    ],
  },
];
